import React from 'react';
import s from './InvoicesBusinessInfo.scss';
import get from 'lodash.get';
import ReactHtmlParser from 'react-html-parser';
import { Box, Text, Cell, Layout, } from '@wix/design-system';
import { addressFormatter } from '@wix/crm-financial-formatters';
import { withTranslation } from '@wix/fe-essentials/i18n';
import { Placement, } from '@wix/ambassador-wix-quotes-web/types';
import { WithBusinessInfoLoader, } from '../../loaders/loaders-builder';
const customaizeInvoiceVerticalLayoutLineProps = {
    size: 'tiny',
    secondary: true,
    weight: 'thin',
};
const BusinessInfoLine = ({ children, verticalLayout, ...props }) => (React.createElement(Box, { wordBreak: "break-word" },
    React.createElement(Text
    // @ts-expect-error
    , { 
        // @ts-expect-error
        size: "tiny", 
        // @ts-expect-error
        secondary: true, 
        // @ts-expect-error
        weight: "thin", ...(verticalLayout ? customaizeInvoiceVerticalLayoutLineProps : {}), ...props, className: `${s.customizeBusinessInfoLine} ${props.className || ''}` }, children)));
const BusinessInfo = ({ t, businessInfo, businessCustomFields, }) => {
    const { name, email, phone, companyId, logo } = businessInfo;
    const description = get(businessInfo, 'businessAddress.description.content');
    const placement = get(businessInfo, 'businessAddress.description.placement');
    const city = get(businessInfo.address, 'city');
    const state = get(businessInfo.address, 'state');
    const country = get(businessInfo.address, 'country');
    const streetName = get(businessInfo.address, 'streetAddress.name');
    const streetNumber = get(businessInfo.address, 'streetAddress.number');
    const street = get(businessInfo.address, 'street');
    const zip = get(businessInfo.address, 'zip');
    const localizedLocation = addressFormatter({
        t,
        // @ts-expect-error
        city,
        // @ts-expect-error
        state,
        // @ts-expect-error
        country,
        // @ts-expect-error
        zip,
        streetNumber,
        streetName,
        street,
    });
    const Location = () => localizedLocation ? (React.createElement(BusinessInfoLine, { dataHook: "business-address", verticalLayout: true }, localizedLocation)) : null;
    const Description = () => description ? (React.createElement(BusinessInfoLine, { dataHook: "business-address-description", verticalLayout: true }, description)) : null;
    const hasLogo = () => logo && logo.match(/(?:[^\/]+)$/);
    const customFields = () => (businessCustomFields ?? []).map(({ displayName, value }, index) => {
        const formattedValue = ReactHtmlParser(value);
        const formattedDisplayName = ReactHtmlParser(displayName);
        return (React.createElement("div", { key: index },
            React.createElement(BusinessInfoLine, { verticalLayout: true, dataHook: `${displayName}-${index}-custom-field`, className: s.customFieldLine }, t('invoice-view:price-quote.view.custom-field', {
                displayName: formattedDisplayName,
                value: formattedValue,
            }))));
    });
    const renderAddress = () => {
        switch (placement) {
            case Placement.Replace:
                return description ? React.createElement(Description, null) : [React.createElement(Location, { key: "location" })];
            case Placement.Before:
                return [React.createElement(Description, { key: "description" }), React.createElement(Location, { key: "location" })];
            case Placement.After:
                return [React.createElement(Location, { key: "location" }), React.createElement(Description, { key: "description" })];
            default:
                return [React.createElement(Location, { key: "location" })];
        }
    };
    const hasCustomFields = businessCustomFields && businessCustomFields.length > 0;
    return (React.createElement(Layout, { alignItems: "flex-end" },
        React.createElement(Cell, { span: 4 },
            !!name && (React.createElement(BusinessInfoLine, { className: s.businessName, weight: "bold", dataHook: "business-name", verticalLayout: true }, name)),
            renderAddress(),
            !!email && (React.createElement(BusinessInfoLine, { dataHook: "business-email", verticalLayout: true }, email)),
            !!phone && (React.createElement(BusinessInfoLine, { dataHook: "business-phone", verticalLayout: true }, t('invoice-view:price-quote.view.business.phone', { phone }))),
            !!companyId && (React.createElement(BusinessInfoLine, { dataHook: "business-company-id", verticalLayout: true }, t('invoice-view:price-quote.view.business.company-id', {
                companyId,
            })))),
        React.createElement(Cell, { span: 4 }, hasCustomFields && (React.createElement("div", { className: `${s.businessInfoDetails} ${s.businessCustomFields}`, "data-hook": "business-custom-fields", style: {
                width: !hasLogo() ? '210px' : undefined,
                marginTop: hasLogo() ? '47px' : '104px',
            } }, customFields()))),
        React.createElement(Cell, { span: 4 })));
};
export const InvoicesBusinessInfo = WithBusinessInfoLoader(withTranslation(['invoice-view', 'locale-data'])(BusinessInfo));
//# sourceMappingURL=InvoicesBusinessInfo.js.map